import React, { Component } from 'react';
import PropTypes from 'prop-types';


import classNames from 'classnames';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import HelpIcon from '@mui/icons-material/Help';
import GuideIcon from '@mui/icons-material/Book';
import ReportIcon from '@mui/icons-material/Report';
import SupportIcon from '@mui/icons-material/ContactSupport';
import ViewModule from '@mui/icons-material/ViewModule';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
//import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
//import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import SearchBox from './SearchBox';
import { ChevronLeft, ChevronRight, SettingsApplications } from '@mui/icons-material';
import { Avatar, Box, type Theme } from '@mui/material';

const drawerWidth = 240;
const miniDrawerWidth = 60;

const s:any = {
  //console.log('theme in header: ',theme);
  //return ({
    appBar: (theme:Theme)=>({
      zIndex: 'zIndex.drawer + 1',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    }),
    appBarShift: (theme:Theme)=>({
      [theme.breakpoints.down('sm')]:{
        width: `calc(100% - ${miniDrawerWidth}px)`,
        marginLeft: miniDrawerWidth,
      },
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    toolbar:{
      display: 'flex',
      justifyContent: 'flex-end'
    },
    searchbar: {
      width:'100%'
    },
    menuButton: {
      marginLeft: 2,
      marginRight: 4,
      position:'absolute',
      left:1
    },
    hide: {
      display: 'none',
    },
    show: {
      display: 'flex',
    },
    topmenu: {
      float: 'right'
    },
    title: {
      marginLeft: 4,
      marginRight: 1,
      position:'absolute',
      left:40,
      color:'white',
      flexGrow: 1, 
      display: { xs: 'none', sm: 'block' } 
    }
  //});
};

class Header extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      anchorEl: null,
      menuopen: false,
      useropen: false,
      useranchor: null,
      settingsopen: false,
      settingsanchor: null,
    };
  }

  handleClick = (menu:any,page:any,index:any)=> () => {
    console.log('handleclick:menu,page,index',menu,page,index);
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
    
  };

  onUserOpen = (event:any) => {
    this.setState({ useranchor: event.currentTarget, useropen:true });
  };

  onUserProfile = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'profile';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserAccount = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'profile';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserAnnouncement = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'announcement';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserSignOut = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'logout';
    this.props.handleSetContent(null,page).then( 
      () => {
      this.props.closeDrawer();
    },
    (reason:any) => {
      console.error(reason); // Error!
    }
  );
  };

  onUserClose = () => {
    this.setState({ useranchor: null, useropen:false });
  };

  onSettingsOpen = (event:any) => {
    this.setState({ settingsanchor: event.currentTarget, settingsopen:true });
  };

  onHelp = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onGuide = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onSupport = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'support';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onAbout = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'about';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onSettingsClose = () => {
    this.setState({ settingsanchor: null, settingsopen:false });
  };

  onKeyPress = (event:any) => {
    if(event.key === 'Enter') this.onSearch(event.target.value);
  }

  onSearch = (query:any) => {
    const {page} = this.props;
    
    //const page = 'search';
    this.props.handleSetContent(query,page,true).then( () => {
      //clear search? no.
    });
  };

  onMenu = (event:any) => {
    this.setState({ anchorEl: event.currentTarget, menuopen:true });
    const page = 'kanban';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onMaintenance = (event:any) => {
    this.setState({ anchorEl: event.currentTarget, menuopen:true });
    const page = 'maintenance';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onClose = () => {
    this.setState({ anchorEl: null, menuopen:false });
  };

  render() {
    const {page, navDrawerOpen, openDrawer, closeDrawer, toggleDrawer, data, classes, theme} = this.props;
    const {onSearched} = this.props;
    const { useropen,useranchor,settingsopen,settingsanchor } = this.state;
    const eti = (data.bd||{}).eti;
    const isMain = (eti===1);
    const adminmenu = isMain?s.show:s.hide;

    //console.log("Entity id",eti)
    const pageTitle = page;
    
    return (
      <Box sx={{ display: 'contents' }}>
        <AppBar position="fixed">
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>

            {/* LEFT */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <IconButton
                color="inherit"
                onClick={navDrawerOpen ? closeDrawer : openDrawer}
                aria-label={navDrawerOpen ? 'Close sidebar' : 'Open sidebar'}
                title={navDrawerOpen ? 'Close sidebar' : 'Open sidebar'}
              >
                {navDrawerOpen ? <ChevronLeft /> : <MenuIcon />}
              </IconButton>

              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {pageTitle || "Dashboard"}
              </Typography>
            </Box>

            {/* RIGHT */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <IconButton><NotificationsIcon /></IconButton>
              <IconButton><SettingsIcon /></IconButton>
              <Avatar sx={{ width: 32, height: 32 }} />
            </Box>

          </Toolbar>
        </AppBar>
      </Box>
    );
  }
}

Header.propTypes = {
  hstyles: PropTypes.object,
  navDrawerOpen: PropTypes.bool,
  openDrawer: PropTypes.func,
  closeDrawer: PropTypes.func,
  toggleDrawer: PropTypes.func
};

//export default Header;
export default Header;
